(function () {
  const STORAGE_KEY = 'amazon_attribution_first_touch';
  const EXPIRY_DAYS = 30;

  function normalize(value) {
    return (value || '').trim().toLowerCase();
  }

  function getStoredAttribution() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);

      if (!raw) return null;

      const data = JSON.parse(raw);

      if (!data.timestamp) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }

      const expiresAt =
        data.timestamp + EXPIRY_DAYS * 24 * 60 * 60 * 1000;

      if (Date.now() > expiresAt) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }

      return data;
    } catch (e) {
      return null;
    }
  }

  function captureFirstTouch() {
    if (getStoredAttribution()) return;

    const params = new URLSearchParams(window.location.search);

    const source = params.get('utm_source');
    const medium = params.get('utm_medium');
    const campaign = params.get('utm_campaign');
    const content = params.get('utm_content');

    // Only store when we actually have campaign attribution
    if (!source && !medium && !campaign && !content) return;

    const data = {
      source: normalize(source),
      medium: normalize(medium),
      campaign: normalize(campaign),
      content: normalize(content),
      timestamp: Date.now()
    };

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function getMatchingRoute(attribution) {
    if (!attribution || !window.amazonAttributionRoutes) {
      return null;
    }

    return window.amazonAttributionRoutes.find(function (route) {
      return (
        normalize(route.source) === attribution.source &&
        normalize(route.medium) === attribution.medium &&
        normalize(route.campaign) === attribution.campaign &&
        normalize(route.content) === attribution.content
      );
    });
  }

function getAmazonAttributionTag(destinationUrl) {
  try {
    const url = new URL(destinationUrl);
    return url.searchParams.get('maas') || '';
  } catch (e) {
    return '';
  }
}

function trackOutboundClick(attribution, destinationUrl) {
  const amazonAttributionTag = getAmazonAttributionTag(destinationUrl);

  const eventData = {
    event: 'amazon_click_out',
    amazon_url: destinationUrl,
    amazon_attribution_tag: amazonAttributionTag,
    utm_source: attribution?.source || '',
    utm_medium: attribution?.medium || '',
    utm_campaign: attribution?.campaign || '',
    utm_content: attribution?.content || ''
  };

  // Google Tag Manager / dataLayer
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(eventData);

  // GA4 direct gtag support
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'amazon_outbound_click', {
      amazon_url: destinationUrl,
      amazon_attribution_tag: amazonAttributionTag,
      utm_source: attribution?.source || '',
      utm_medium: attribution?.medium || '',
      utm_campaign: attribution?.campaign || '',
      utm_content: attribution?.content || ''
    });
  }

// Meta Pixel custom event
if (typeof window.fbq === 'function') {
  window.fbq('trackCustom', 'AmazonClickOut', {
    utm_source: attribution?.source || '',
    utm_medium: attribution?.medium || '',
    utm_campaign: attribution?.campaign || '',
    utm_content: attribution?.content || '',
    amazon_attribution_tag: amazonAttributionTag
  });
}
}

  captureFirstTouch();

function updateAmazonButtons() {
  const attribution = getStoredAttribution();
  const route = getMatchingRoute(attribution);

  document.querySelectorAll('.amazon-buy-button a').forEach(function (link) {

    // Save original fallback URL only once
    if (!link.dataset.amazonFallback) {
      link.dataset.amazonFallback = link.href;
    }

    // Matching campaign found
    if (route && route.url) {
      link.href = route.url;
    } else {
      // No mapping - restore normal Amazon URL
      link.href = link.dataset.amazonFallback;
    }
  });
}


// Run immediately
updateAmazonButtons();


// Run again once page is ready
document.addEventListener('DOMContentLoaded', function () {
  updateAmazonButtons();
});


// EComposer may inject/re-render elements after initial page load
const amazonButtonObserver = new MutationObserver(function () {
  updateAmazonButtons();
});

amazonButtonObserver.observe(document.body, {
  childList: true,
  subtree: true
});


// Track clicks
document.addEventListener('click', function (event) {
  const link = event.target.closest('.amazon-buy-button a');

  if (!link) return;

  const attribution = getStoredAttribution();

  trackOutboundClick(
    attribution,
    link.href
  );
});
})();